import React from 'react'

function About() {
    return (
        <div>
            <h1>Hiii About</h1>
        </div>
    )
}

export default About
